import { render, staticRenderFns } from "./NavBlock.vue?vue&type=template&id=eb145988&scoped=true"
import script from "./NavBlock.vue?vue&type=script&lang=js"
export * from "./NavBlock.vue?vue&type=script&lang=js"
import style0 from "./NavBlock.vue?vue&type=style&index=0&id=eb145988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb145988",
  null
  
)

export default component.exports